import { type RouteObject } from 'react-router'

import { ProjectNewForm } from 'features/project-form'
import { Home as HomeContainer } from 'features/projects/Container'
import { HOME } from 'features/projects/paths'

export const projectsRoutes: RouteObject[] = [
  {
    path: HOME,
    element: (
      <HomeContainer
        renderProjectNewForm={({ reservedKeywords, onClose }) => (
          <ProjectNewForm
            reservedKeywords={reservedKeywords}
            handleClose={onClose}
          />
        )}
      />
    ),
  },
]
